// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".container[data-v-6c0186ce]{display:flex;flex-direction:column;align-items:center;grid-gap:24px;gap:24px}.img[data-v-6c0186ce]{width:100%;aspect-ratio:2}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
